import * as React from 'react';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import ListItems2 from './ListItems2';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ContenedorHistorial from './historial/ContenedorHistorial'
import ContenedorIncidencias from './incidencias/ContenedorIncidencias';
import Error404 from './Error404';
import ContenedorSetings from './setings/ContenedorSetings';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import HistorialDetalle from './historial/HistorialDetalle';
import AltaIncidenciasPasos from './incidencias/incidenciasregistro/AltaIncidenciasPasos';
import { obtenermenutiporiesgo, obtenermenuramoseguro, obtenermenusecuelaconsecuencia, obtenermenucontrolincapacidad } from '../Redux/PdimMenuDucks'
import { useDispatch } from 'react-redux'
import DetallesLotes from './incidencias/lote/DetallesLotes';
import logo from '../assets/img/Logoblanco.png';
import ContenedorUser from './usuarios/ContenedorUser';
import { estatususer } from '../Redux/Users';

const drawerWidth = 200;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      color: 'white',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.down('xs')]: {
          width: theme.spacing(1),
        },
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(6),
        },
      }),
    },
  }),
);
const darkTheme = createTheme({

  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            color: '#fff',
            backgroundColor: '#5d5f4d',
          }
        },
        {
          props: { variant: 'text' },
          style: {
            color: '#ffffff',
          }
        },
        {
          props: { variant: 'contained', color: 'success' },
          style: {
            backgroundColor: '#263f18',
          },
        },
      ],
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#203a19',
          color: "red",
        }
      }
    },
  },

  palette: {
    mode: 'dark',
    text: {
      primary: '#fff',
      secondary: '#fff',
    },
    primary: {
      main: '#3a7d44'
    },
    secondary: {
      main: '#fff',
    },
    default: {
      main: '#530303'
    },
    info: {
      main: '#000'
    },
    success: {
      main: '#3f612d'
    },
    warning: {
      main: '#000'
    },
    error: {
      main: '#000'
    },
  },
});

const mdTheme = createTheme(
  {
    components: {
      MuiButton: {
        variants: [
          {
            props: { variant: 'outlined' },
            style: {
              color: '#688716'
            }
          },
          {
            props: { variant: 'contained', color: 'success' },
            style: {
              backgroundColor: '#688716',
            },
          },
        ],
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: '#688716',
            color: "red",
          }
        }
      },
    },
    palette: {
      primary: {
        main: '#688716'
      },
      secondary: {
        main: '#688716',
      },
      default: {
        main: '#fff'
      },
      info: {
        main: '#ffffff'
      },
      success: {
        main: '#688716'
      },
      warning: {
        main: '#FF9B12'
      },
      error: {
        main: '#F44336'
      }
    }
  });

function DashboardContent(props) {
  const darks = sessionStorage.getItem('dark')
  const [open, setOpen] = React.useState(true);
  const [dark, SetDark] = React.useState(Boolean(darks))
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const handchangedark = () => {
    SetDark(!dark)
    if (dark === true) {
      sessionStorage.setItem('dark', (false))
    } else {
      sessionStorage.setItem('dark', (true))
    }
  }
  return (
    <Router>
      <ThemeProvider theme={darks === 'true' ? darkTheme : mdTheme}>
        <Box sx={{ display: 'flex', }}>
          <CssBaseline />
          <Drawer variant="permanent" open={open}>
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: [1],
              }}
            >
              <Box padding='9px'>
                <img src={logo} alt='logo plant for the plannet' />
              </Box>

              <IconButton onClick={toggleDrawer}>
                <ChevronLeftIcon style={{ color: '#fff' }} />
              </IconButton>
            </Toolbar>

            <ListItems2
            />
          </Drawer>
          <Box
            component="main"
            sx={{

              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            }}
          >
            <Toolbar />

            <Container maxWidth="false" sx={{ mt: 2, mb: 1 }} >
              <Routes>
                <Route path="/" element={<ContenedorIncidencias
                  appbar={toggleDrawer}
                  open={open}
                />} />
                <Route path="/incidencias/*"
                  element={<ContenedorIncidencias
                    appbar={toggleDrawer}
                    open={open} />} />
                <Route path='/incidencias/add'
                  element={<AltaIncidenciasPasos
                    appbar={toggleDrawer}
                    open={open} />} />
                <Route path='/incidencias/:Id'
                  element={<DetallesLotes
                    appbar={toggleDrawer}
                    open={open} />} />
                <Route path='/historial/*'
                  element={<ContenedorHistorial
                    appbar={toggleDrawer}
                    open={open} />} />
                <Route path='/historial/:Id/:Cod/:Bd'
                  element={<HistorialDetalle
                    appbar={toggleDrawer}
                    open={open} />} />
                <Route path='/usuarios'
                  element={<ContenedorUser
                    appbar={toggleDrawer}
                    open={open} />} />
                <Route path='/setings'
                  element={<ContenedorSetings
                    cambiartema={handchangedark}
                    darkestatus={dark}
                    appbar={toggleDrawer}
                    open={open} />} />
                <Route path='*'
                  element={<Error404
                    appbar={toggleDrawer}
                    open={open} />} />
              </Routes>
            </Container>
          </Box>
        </Box>
      </ThemeProvider>
    </Router>
  );
}

export default function Dashboard(props) {
  const dispatch = useDispatch();
  React.useEffect(() => {
    const obtenerInfo = () => {
      dispatch(obtenermenutiporiesgo())
      dispatch(obtenermenuramoseguro())
      dispatch(obtenermenusecuelaconsecuencia())
      dispatch(obtenermenucontrolincapacidad())
      dispatch(estatususer())
    }
    obtenerInfo()
  }, [dispatch])
  return <DashboardContent />;
}